<div>
  <div class="col-12 signin-xlarge" i18n="Sign In | Sign In header">Sign In</div>
  <div class="col-12">
    <accela-button-primary pRipple i18n-label i18n="Sign In | LogIn Button" icon="accelicons accelicons-open-in" btnClass="text-upper" iconPos="right"
                           (onClicked)="signInBtnClick()" label="Sign In" [disabled]="!(idpInfoLoaded && !adminMode)"></accela-button-primary>
  </div>
  <div class="col-12 pr-4">
    <label class="" i18n="You'll be redirected to another site where you can register or sign in using our new Single Sign-on experience. | SSO Login Description">You'll be redirected to another site where you can register or sign in using our new Single Sign-on experience.</label>
  </div>
    <accela-separator style="background-color: #e4dddd;"></accela-separator>
    <p-footer>
      <div class="text-center text-bold pt-2" i18n="Not Registered? | Register">Not Registered?</div>
      <p class="text-center "><a [ngClass]="idpInfoLoaded ? 'pointCursor' : 'disabled'" ><span (keydown.enter)="newUserRegistration($event)" (click)="newUserRegistration($event)" tabindex="0" class="text-upper footerText" i18n="Create an Account | Create an Account" > Create an Account</span></a></p>
    </p-footer>
  </div>
